import { CommonFacade, SessionService } from '@amwager/data-access';
import {
  CardDatePipe,
  CardNamePipe,
  CardNumEndPipe,
  IsEmptyPipe,
  LoadService,
  UnsubscribeObservableService
} from '@amwager/util';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import {
  Environment,
  eProtectConfigure,
} from '@amwager/util-ts';
import { FundingFacade, IDebitCreditCard } from '@amwager/funding/data-access';
import { Observable, Subscription, interval, of, startWith, takeUntil } from 'rxjs';
import { DatePipe, CommonModule, AsyncPipe } from '@angular/common';
import { AlertController, IonIcon } from '@ionic/angular/standalone';
import { forEach } from 'lodash';
import { AddAccountCardComponent } from './add-account-card/add-account-card.component';
import { Router } from '@angular/router';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let EprotectIframeClient: any;
declare let iframeIsReady: boolean;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let callbackDataResponse: any;
let showErrorMsg: string;

@Component({
  selector: 'feature-ion-debit-credit-card',
  templateUrl: './debit-credit-card.component.html',
  styleUrls: ['./debit-credit-card.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
    ReactiveFormsModule,
    AddAccountCardComponent,
    IsEmptyPipe,
    CardNamePipe,
    CardDatePipe,
    CardNumEndPipe
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DebitCreditCardComponent extends UnsubscribeObservableService implements OnInit {

  showAddCard: boolean = false;

  debitAndCreditCardForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.debitAndCreditCardForm?.controls }



  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private eProtectiframeClient: any;

  $invervalIframeIsReady!: Subscription;
  $isEProtectURLLoaded!: Subscription;

  isIFrameReady: boolean = false;
  showErrorMsg = '';

  isEProtectURLLoaded: boolean = false;

  private subsAddCardResponse!: Subscription;

  private subsDeleteCardResponse!: Subscription;

  orderId?: string;

  cards$!: Observable<IDebitCreditCard[]>;

  private subsGetCardResponse!: Subscription;

  showCardList = false;
  amount!: number;

  awaitFee: boolean = false;
  fee!: number;
  total!: number;

  private tmsId?: string;

  private subsDepositCardResponse!: Subscription;

  // debitAndCreditCardForm!: FormGroup;

  // showAddCardContainer = false;

  isDepositing = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly sessionService: SessionService,
    private readonly loadService: LoadService,
    private readonly fundingFacade: FundingFacade,
    private readonly elementRef: ElementRef,
    // private readonly datePipe: DatePipe,
    private readonly cdRef: ChangeDetectorRef,
    private readonly commonFacade: CommonFacade,
    private readonly alertCtrl: AlertController,
    private readonly router: Router,
    private readonly ngZone: NgZone
  ) {
    super();

    this.subsAddCardResponse = this.fundingFacade.isAddDebitCreditCardSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe(({response, isSuccess}) => {

      if (!isSuccess) return;

      this.showAddCard = false;
      this.cdRef.detectChanges();

      // this.subsAddCardResponse?.unsubscribe();
    });


    this.fundingFacade.getCardFee$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((cardFee) => {

        this.fee = cardFee?.Fee as number;
        this.total = cardFee?.TotalAmount || this.amount;
        this.awaitFee = false;

        this.cdRef.markForCheck();
      });
  }



  ngOnInit() {
    // update branch
    // this.loadCDNs();
    this.observerTmsIds();
    this.initForm();
    // this.formVal['amount']?.setValue(25);
    // this.amount = 25;
    this.fee = 0;
    this.total = this.amount;

    this.fundingFacade.getDebitCreditCard();
    // this.fundingFacade.isGetDebitCreditCardSuccess$().subscribe(res=>console.log(res));
    this.subsGetCardResponse = this.fundingFacade.getListCards$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((response) => {
      if (response !== undefined) {
        this.cards$ = of(response);
        this.showCardList = true;
      }
      // this.subsGetCardResponse?.unsubscribe();
      this.cdRef.markForCheck();
    });

    // this.fee = 5;
    // this.total = (0 + this.fee);
  }

  // ngOnChanges() {
  //   // if (this.showAddCard) this.addCard();
  // }

  // override ngOnDestroy(): void {
  //   this.clearStateProcess();
  //   this.removeCDNs();
  // }

  showAddCardFn(isShow: boolean): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('DebitCreditCardComponent:showAddCardFn', false);
      return;
    }

    this.showAddCard = isShow;
    this.cdRef.markForCheck();
  }

  private observerTmsIds(): void {
    this.commonFacade?.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  chooseAmount(amount: number): void {
    this.formVal['amount']?.setValue(amount);
    this.amount = amount;
    // this.total = (amount + this.fee);
    // this.total = this.amount + (this.fee || 0);

    this.fee = 0;
    this.total = this.amount;

    if (this.orderId && this.amount > 0 && this.formVal['amount'].valid) this.fundingFacade.setCardFee(true, this.amount, 'CreditCard');
    else {
      this.fee = 0;
      this.total = this.amount;
    }

    this.awaitFee = true;
  }

  private initForm(): void {
    this.debitAndCreditCardForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.minLength(25), Validators.maxLength(500)]]
    });
  }
  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  async confirmRemoveCard(orderId: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Confirmation',
      message: 'Are you sure about removing this bank account?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            this.ngZone.run(()=>{
              this.removeCard(orderId);
            });
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });

    await alert.present();
  }

  removeCard(orderId: string): void {
    this.fundingFacade.deleteDebitCreditCard(orderId);
    this.subsDeleteCardResponse = this.fundingFacade.isDeleteDebitCreditCardSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe(({response, isSuccess}) => {
      if (!isSuccess) {
        this.showAlertMessage('Error', response.error.Message);
      }
      this.subsDeleteCardResponse?.unsubscribe();
    });

    // this.cdRef.detectChanges();
    // this.cdRef.markForCheck();
  }


  addCard(): void {
    // this.showAddCard = true;

    const id = this.sessionService.generateSessionId();
    const orderId = this.sessionService.generateSessionId();

    const message = {
      "id":  btoa(id).substring(0,24), //unique, max 25
      "orderId": btoa(orderId).substring(0, 24), //unique, max 256
    };

    if (message.id) {
      this.eProtectiframeClient.getPaypageRegistrationId(message);
    }

    // this.showAddCardContainer = !this.showAddCardContainer;
  }


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chooseCard($event: any, method: string, card: string, orderId: string): void {

    const cardRows = this.elementRef.nativeElement.querySelectorAll(
      '.card-per-row'
    );
    cardRows.forEach((cardRow: HTMLElement) => {
      cardRow.classList.remove('active');
    });

    // const creditCard = $event.target as HTMLElement;
    const creditCard = this.elementRef.nativeElement.querySelector(
      '.card-content .card-list-container #'
      + card
      + '.card-per-row'
    );

    this.fee = 0;
    this.total = this.amount;

    // if (creditCard.classList.contains('selector')) {
      if (creditCard.classList.contains('active')) {
        creditCard.classList.remove('active');
        this.orderId = '';

        this.fee = 0;
        this.total = this.amount;
      }
      else {
        creditCard.classList.add('active');
        this.orderId = orderId;

        if (this.orderId && this.amount > 0 && this.formVal['amount'].valid) this.fundingFacade.setCardFee(true, this.amount, 'CreditCard');
        else {
          this.fee = 0;
          this.total = 0;
        }

      }
    // }
  }


  depositAmount(): void {
    this.amount = this.formVal['amount']?.value;

    this.fee = 0;
    this.total = this.amount;

    setTimeout(() => {
      if (this.orderId && this.amount > 0 && this.formVal['amount'].valid) this.fundingFacade.setCardFee(true, this.amount, 'CreditCard');
      else {
        this.fee = 0;
        this.total = this.amount;
      }
    }, 300);

    this.awaitFee = true;
  }

  deposit(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('DebitCreditCardComponent:deposit', false);
      return;
    }

    if (this.debitAndCreditCardForm.valid && !this.awaitFee && this.amount && this.orderId && this.tmsId) {
      this.isDepositing = true;

      this.fundingFacade.depositDebitCreditCard(
        this.amount,
        this.orderId,
        this.tmsId
      );
      this.subsDepositCardResponse = this.fundingFacade.isDepositDebitCreditCardSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Deposit Error', response.error.Message);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }


        this.subsDepositCardResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('', 'Successfully Deposited Amount');
          this.debitAndCreditCardForm.reset();
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.debitAndCreditCardForm);
    }
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
